module.exports = __webpack_public_path__ + "img/colour.3052e609.webp";